:host, :host > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:host {
  color: var(--cwc-hero-title-color, #fff);
  background-repeat: no-repeat;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
}

div {
  width: 100%;
  max-width: 1070px;
  text-align: center;
}

h2 {
  margin-top: auto;
  margin-bottom: 32px;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 500;
  font-size: 64px;
  line-height: 72px;
}

h2 > span {
  color: var(--cwc-hero-sub-title-color, #FFAD00);
}

p {
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  font-size: 36px;
  line-height: 39px;
  max-width: 940px;
  margin-top: 0;
  margin-bottom: auto;
}
